var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a", { on: { click: _vm.shareViaWebShare } }, [
    _vm._v("\n  " + _vm._s(_vm.$msg("product.share.button", "product")) + "\n")
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }